module.exports = __webpack_public_path__ + "static/media/box-3.eec17b29.png";